import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/sendCode.svg'


const _withScopeId = n => (_pushScopeId("data-v-332638cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popUpWindow register" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"c-p-3 shadow\" data-v-332638cb><ul class=\"registerSteps\" data-v-332638cb><li class=\"completed\" data-v-332638cb><small class=\"line\" data-v-332638cb></small><span data-v-332638cb>1</span></li><li class=\"selected\" data-v-332638cb><span data-v-332638cb>2</span></li></ul></div>", 1)
const _hoisted_3 = { class: "c-p-3" }
const _hoisted_4 = { class: "stepHeader" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1))
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "c-m-0" }
const _hoisted_8 = { class: "p-float-label" }
const _hoisted_9 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-R" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Password = _resolveComponent("Password")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("register.sendCode")), 1)
      ]),
      _hoisted_5,
      _createElementVNode("img", {
        class: "sendCodeImg",
        src: _imports_0,
        alt: _ctx.$t('accessibility.register.code')
      }, null, 8, _hoisted_6),
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t("verification.check_" + _ctx.type)), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("verification.check_description_" + _ctx.type)), 1),
      _createElementVNode("h3", _hoisted_7, _toDisplayString(_ctx.$t("verification.enter_code")), 1),
      _createElementVNode("span", _hoisted_8, [
        _createVNode(_component_Password, {
          feedback: false,
          id: "verificationToken",
          type: "text",
          modelValue: _ctx.verificationToken,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.verificationToken) = $event)),
          name: "verificationToken"
        }, null, 8, ["modelValue"])
      ]),
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t("user_email.wrong_code")), 1))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        "event-name": "confirmRegistrationButton",
        "event-from": "/register",
        class: "defaultButton next",
        onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkVerificationToken && _ctx.checkVerificationToken(...args)), ["prevent"]))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("register.confirmRegistration")) + " ", 1),
        _hoisted_10
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "cancel",
        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resendCode && _ctx.resendCode(...args)), ["prevent"]))
      }, _toDisplayString(_ctx.$t("register.resendCode")), 1)
    ])
  ]))
}